import Axios from "axios";
import tokenUtil from '@/utils/TokenUtil';
export default {
  get(url, obj) {
    return Axios.get(url, { params: { ...obj }, headers: { 'Authorization': tokenUtil.getToken() } });
  },
  post(url, obj) {
    console.log(tokenUtil.getToken(), 213412)
    return Axios.post(url, { ...obj }, { headers: { 'Authorization': tokenUtil.getToken() } });
  },
  put(url) {
    return Axios.put(url);
  },
  delete(url) {
    return Axios.delete( url);
  }
}
